<aside class="wishlist-privacy-hint">
  <span aria-hidden="true">privacy</span>
  <p>Goście widzą tylko udostępnioną wishlistę — bez prywatnych danych domu.</p>
</aside>
